/* src/app/modules/user/usercontact/usercontact.component.css */
.example-icon {
  padding: 0 14px;
}
.toolbar-spacer {
  flex: 1 1 auto;
}
.index-row {
  flex: 5;
}
.index-button {
  flex: 1;
}
.click {
  cursor: pointer;
}
.qrcode {
  display: inline;
}
input[type=file] {
  display: none;
}
.custom-file-upload {
  border: 1px solid white;
  background-color: #e3fd64;
  color: #1a1d23;
  display: inline-block;
  padding: 6px 12px;
  cursor: pointer;
}
.custom-file-upload:hover {
  background-color: #8cb7c9;
}
.downloadButton {
  color: white;
  padding: 9px;
}
label {
  margin-bottom: 0px;
}
.flex-container {
  display: flex;
  flex-flow: row wrap;
}
.flex-container > div {
  margin: 10px;
  text-align: left;
}
.loader-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 300px;
}
mat-card,
.mat-mdc-card {
  border-radius: 8px;
}
.form-section {
  width: 100%;
}
mat-form-field textarea {
  resize: vertical;
}
button mat-icon {
  vertical-align: middle;
}
.invoice-settings-page {
  padding-top: 24px;
  padding-bottom: 24px;
  background:
    linear-gradient(
      180deg,
      #f6f8fc 0%,
      #fbfcfe 100%);
}
.us-page-header__actions {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}
.settings-card {
  border-radius: 18px;
  box-shadow: 0 8px 28px rgba(16, 24, 40, 0.07);
  border: 1px solid #e8edf4;
  padding: 18px;
  background: #fff;
}
.settings-card--layouts {
  overflow: hidden;
}
.section-eyebrow {
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: .6px;
  font-weight: 700;
  color: #4d6b8a;
  margin-bottom: 6px;
}
.section-title {
  font-size: 22px;
  font-weight: 700;
  color: #16324f;
}
.section-text {
  color: #667085;
  font-size: 14px;
}
.invoice-layout-card {
  position: relative;
  border: 1px solid #dbe4ee;
  border-radius: 18px;
  background: #fff;
  cursor: pointer;
  transition: all .22s ease;
  height: 100%;
  overflow: hidden;
  box-shadow: 0 4px 14px rgba(16, 24, 40, .04);
}
.invoice-layout-card:hover {
  transform: translateY(-3px);
  border-color: #9cb3ca;
  box-shadow: 0 16px 34px rgba(22, 50, 79, 0.10);
}
.invoice-layout-card.selected {
  border: 2px solid #16324f;
  box-shadow: 0 18px 38px rgba(22, 50, 79, 0.16);
}
.layout-topbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 14px 14px 0 14px;
  min-height: 44px;
}
.layout-tag {
  display: inline-flex;
  align-items: center;
  border-radius: 999px;
  background: #eef4fb;
  color: #305578;
  font-size: 12px;
  font-weight: 700;
  padding: 5px 10px;
}
.layout-selected-pill {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  border-radius: 999px;
  background: #16324f;
  color: #fff;
  font-size: 12px;
  font-weight: 700;
  padding: 5px 10px;
}
.layout-selected-pill mat-icon {
  font-size: 16px;
  width: 16px;
  height: 16px;
}
.invoice-layout-preview {
  padding: 14px;
  margin: 10px 14px 0;
  border-radius: 14px;
  background:
    linear-gradient(
      180deg,
      #f8fbff 0%,
      #f2f6fb 100%);
  border: 1px solid #e3eaf3;
  min-height: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.invoice-layout-preview img {
  max-height: 180px;
  width: auto;
  object-fit: contain;
  border-radius: 8px;
  box-shadow: 0 8px 24px rgba(22, 50, 79, 0.08);
}
.invoice-layout-content {
  padding: 16px 16px 18px;
}
.layout-title {
  font-size: 18px;
  font-weight: 700;
  color: #101828;
}
.layout-subtitle {
  font-size: 13px;
  color: #4d6b8a;
  font-weight: 600;
}
.layout-description {
  color: #667085;
  font-size: 14px;
  line-height: 1.5;
  min-height: 63px;
}
.layout-actions {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}
.layout-select-btn {
  color: var(--cf-brand-dark, #d48f00) !important;
  font-weight: 600 !important;
}
.layout-select-btn:hover {
  color: #b8790a !important;
}
.form-block {
  padding: 16px;
  border: 1px solid #e7ecf2;
  border-radius: 14px;
  background: #fafcff;
}
.form-block-title {
  font-size: 15px;
  font-weight: 700;
  color: #16324f;
}
.form-extra {
  margin-top: 8px;
}
.color-picker {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(36px, 1fr));
  gap: 10px;
  max-width: 480px;
  margin-bottom: 8px;
}
.color-option {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  cursor: pointer;
  border: 3px solid transparent;
  transition: all 0.15s ease;
  position: relative;
}
.color-option:hover {
  transform: scale(1.1);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
}
.color-option.selected {
  border-color: var(--cf-brand-dark, #d48f00);
  box-shadow: 0 0 0 2px #fff, 0 0 0 4px var(--cf-brand-dark, #d48f00);
}
.color-option.custom-color {
  background:
    conic-gradient(
      red,
      yellow,
      lime,
      aqua,
      blue,
      magenta,
      red);
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}
.color-option.custom-color input[type=color] {
  width: 100%;
  height: 100%;
  border: none;
  cursor: pointer;
  opacity: 0;
}
@media (max-width: 767px) {
  .settings-card {
    padding: 14px;
  }
  .invoice-layout-preview {
    min-height: 170px;
  }
  .layout-description {
    min-height: auto;
  }
}
.preview-btn .mat-mdc-progress-spinner {
  display: inline-block;
  vertical-align: middle;
}
.preview-btn ::ng-deep svg {
  width: 18px !important;
  height: 18px !important;
}
.us-page {
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 18px;
  min-height: 100%;
  box-sizing: border-box;
}
.us-page-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
  background: #fff;
  border: 1px solid #e5e7eb;
  border-left: 3px solid #e3fd64;
  border-radius: 12px;
  padding: 16px 20px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, .06);
}
.us-page-header__left {
  display: flex;
  align-items: center;
  gap: 14px;
}
.us-page-header__icon {
  width: 44px;
  height: 44px;
  border-radius: 12px;
  background: rgba(227, 253, 100, .10);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.us-page-header__icon mat-icon {
  color: var(--cf-brand-dark);
  font-size: 24px;
  width: 24px;
  height: 24px;
}
.us-page-header__title {
  margin: 0;
  font-size: 18px;
  font-weight: 700;
  color: #111827;
  letter-spacing: -.02em;
}
.us-page-header__sub {
  margin: 3px 0 0;
  font-size: 12.5px;
  color: #6b7280;
}
.us-btn-save {
  background: #e3fd64 !important;
  color: rgba(0, 0, 0, .85) !important;
  font-weight: 600 !important;
  border-radius: 8px !important;
  display: inline-flex !important;
  align-items: center;
  gap: 6px;
  box-shadow: 0 1px 6px rgba(227, 253, 100, .28) !important;
}
.us-btn-secondary {
  border-radius: 8px !important;
  display: inline-flex !important;
  align-items: center;
  gap: 6px;
  color: #374151 !important;
  width: 100%;
  justify-content: center;
}
.us-layout {
  display: grid;
  grid-template-columns: 1fr 270px;
  gap: 18px;
  align-items: start;
}
.us-layout__main {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.us-layout__side {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.us-section {
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 1px 3px rgba(0, 0, 0, .04);
}
.us-section__head {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 18px;
  border-bottom: 1px solid #f0f0f0;
  background: #fafbfc;
}
.us-section__icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border-radius: 7px;
  background: rgba(227, 253, 100, .09);
  flex-shrink: 0;
}
.us-section__icon mat-icon {
  color: #e3fd64;
  font-size: 16px;
  width: 16px;
  height: 16px;
}
.us-section__title {
  margin: 0;
  font-size: 13.5px;
  font-weight: 700;
  color: #111827;
}
.us-section__body {
  padding: 16px 18px;
}
.us-section__body--center {
  display: flex;
  align-items: center;
  justify-content: center;
}
.us-grid {
  display: grid;
  grid-template-columns: repeat(12, 1fr);
  gap: 0 12px;
}
.us-g-2 {
  grid-column: span 2;
}
.us-g-3 {
  grid-column: span 3;
}
.us-g-4 {
  grid-column: span 4;
}
.us-g-6 {
  grid-column: span 6;
}
.us-g-8 {
  grid-column: span 8;
}
.us-g-9 {
  grid-column: span 9;
}
.us-g-12 {
  grid-column: span 12;
}
.us-mat-field {
  width: 100%;
}
.us-mat-field .mat-mdc-form-field-subscript-wrapper {
  display: none;
}
.us-checks {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.us-checks-row {
  display: flex;
  flex-wrap: wrap;
  gap: 8px 28px;
}
.us-section-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  align-items: start;
}
.us-subsection {
  margin-top: 14px;
  padding-top: 14px;
  border-top: 1px solid #f0f0f0;
}
.us-subsection__title {
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: .05em;
  color: #6b7280;
  margin-bottom: 10px;
}
.us-hint {
  font-size: 12px;
  color: #9ca3af;
}
.us-hint-icon {
  font-size: 16px;
  vertical-align: middle;
  color: #9b9b9b;
}
.us-hint-text {
  font-size: 12px;
  color: #9b9b9b;
  margin: 4px 0 0 28px;
}
.us-grid mat-form-field {
  width: 100%;
}
@media (max-width: 960px) {
  .us-layout {
    grid-template-columns: 1fr;
  }
  .us-section-row {
    grid-template-columns: 1fr;
  }
  .us-g-2,
  .us-g-3 {
    grid-column: span 4;
  }
  .us-g-4 {
    grid-column: span 6;
  }
}
@media (max-width: 600px) {
  .us-page {
    padding: 12px;
    gap: 12px;
  }
  .us-grid {
    grid-template-columns: 1fr 1fr;
  }
  .us-g-2,
  .us-g-3,
  .us-g-4,
  .us-g-6,
  .us-g-8,
  .us-g-9,
  .us-g-12 {
    grid-column: span 2;
  }
}
/*# sourceMappingURL=usercontact.component.css.map */
